
import api_list from "@/constant/apiUrl";
import app_config from "@/constant/config";
import { startRequest } from "@/utility/helper/requestHelper";

export const getListCareer = async (params:any) => {
  const apiData = {
    url: api_list.career,
    method: "GET",
    params: {
      page: 1,
      limit: 999,
      ...params
    }
  };

  return startRequest(apiData, app_config.api_static);
};

export const getCareerField = async () => {
  const apiData = {
    url: api_list.careerField,
    method: "GET",
  };

  return startRequest(apiData, app_config.api_static);
};

export const getCareerLocation = async () => {
  const apiData = {
    url: api_list.careerLocation,
    method: "GET",
  };

  return startRequest(apiData, app_config.api_static);
};

export const getDetailCareer = async (params:any) => {
  const apiData = {
    url: api_list.careerDetail,
    method: "GET",
    params: {
      ...params
    }
  };

  return startRequest(apiData, app_config.api_static);
};


export const postCareer = async (data:any) => {
  const apiData = {
    url: '/careers/send-application',
    method: "POST",
    data: {
      ...data
    }
  };

  return startRequest(apiData, app_config.api_static);
};

